import { render } from "./CRMHigh.vue?vue&type=template&id=5aa7109a&scoped=true"
import script from "./CRMHigh.vue?vue&type=script&lang=js"
export * from "./CRMHigh.vue?vue&type=script&lang=js"

import "./CRMHigh.vue?vue&type=style&index=0&id=5aa7109a&scoped=true&lang=css"
import "./CRMHigh.vue?vue&type=style&index=1&id=5aa7109a&lang=css"
script.render = render
script.__scopeId = "data-v-5aa7109a"

export default script